







































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  format,
  isPast,
  isToday,
  getDaysInMonth,
  isWithinRange,
  endOfDay,
  startOfDay,
} from 'date-fns';
import { Icon } from '@/pages/profile/components';
import { fillWeek, getNextMonth, getPrevMonth } from './tools';
import Navi from '../navi';
import { Items } from './types';
import { log } from 'util';

@Component({
  components: {
    Icon,
    Navi,
  },
})
export default class CalendarMonth extends Vue {
  @Prop({ type: Array, required: true })
  items: Items;

  @Prop({ type: Number, required: true })
  month: number;

  @Prop({ type: Number, required: true })
  year: number;

  get bgColorStyle(): string {
    const { colorMenuMain } = this.$store.state.regionProfile;
    if (!colorMenuMain) return '';
    return `#${colorMenuMain}`;
  }

  get nextMonth() {
    return getNextMonth(this.month);
  }

  get prevMonth() {
    return getPrevMonth(this.month);
  }

  get weeks() {
    const { items, year } = this;

    const month = this.month - 1;
    const daysInMonth = getDaysInMonth(new Date(year, month));
    const weeks: Array<Array<any>> = [];

    const prevMonth = 0;
    const nextMonth = daysInMonth + 1;

    let week = fillWeek();
    let filled = false;

    for (let date = prevMonth; date <= nextMonth; date++) {
      const day = new Date(year, month, date);
      let dayOfWeek = day.getDay() - 1;
      if (dayOfWeek < 0) dayOfWeek = 6;
      let curr;
      let type: Array<string> = [];

      const [item] = items.filter(({ date }) =>
        isWithinRange(date, startOfDay(day), endOfDay(day)),
      );

      if (date === prevMonth) curr = { prev: true };
      else if (date === nextMonth) curr = { next: true };
      else {
        if (item && item.items.length) {
          const typeData: Set<string> = new Set();
          item.items.forEach(({ type }) => typeData.add(type));
          type = Array.from(typeData);
        }
        curr = {
          day,
          types: type,
          date: day.getDate(),
          isToday: isToday(day),
          active: !!item,
        };
      }

      week[dayOfWeek] = curr;
      filled = true;

      if (dayOfWeek === 6) {
        weeks.push([...week]);
        week = fillWeek();
        filled = false;
      }
    }

    if (filled) weeks.push([...week]);
    return weeks;
  }

  clickPrevMonth() {
    this.$emit('prevMonth');
  }

  clickNextMonth() {
    this.$emit('nextMonth');
  }

  openPopup(value: boolean, day: string) {
    if (!value) return;
    this.$emit('openPopup', format(day, 'YYYY-MM-DD'));
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/calendar/components/calendar/components/month/CalendarMonth.vue